<template>
  <div class="wrap">
    <div class="container lnb">
      <div class="contents_wrap">
        <div class="contents">
            <div class="title">
              {{ title }}
              <div class="clear"></div>
            </div>
          <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="120px" class="demo-ruleForm">
            <el-form-item label="팝업상태" prop="p_is_display">
              <el-radio-group v-model="ruleForm.p_is_display">
                <el-radio label="1">사용</el-radio>
                <el-radio label="0">대기</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="팝업타입" prop="p_type">
              <el-radio-group v-model="ruleForm.p_type" :disabled="p_idx">
                <el-radio :label="1">PC</el-radio>
                <el-radio :label="0">모바일</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="제목" prop="p_title">
              <el-input type="text" id="p_title"  v-model="ruleForm.p_title" >
              </el-input>
            </el-form-item>
            <el-form-item label="사진" prop="file">
              <el-upload
                action=""
                class="avatar-uploader"
                list-type="picture-card"
                :auto-upload="false"
                :show-file-list="false"
                :file-list="ruleForm.file"
                :on-change="handleFileChange"
                :on-exceed="handleFileExceed"
              >



                <div class="el-upload__tip" slot="tip" v-if="ruleForm.p_type === 1">권장이미지 :  가로기준 500px</div>
                <i class="el-icon-plus avatar-uploader-icon" v-if="ruleForm.file.length === 0"></i>
                <div v-else>
                  <img :src="ruleForm.file[0].url" alt="" class="avatar">
                </div>
              </el-upload>
            </el-form-item>
            <el-form-item label="팝업기간" prop="p_dateRange">
              <el-date-picker
                v-model="ruleForm.p_dateRange"
                type="daterange"
                range-separator="~"
                value-format="yyyy-MM-dd"
                start-placeholder="시작날짜"
                end-placeholder="끝 날짜"
                >
              </el-date-picker>
            </el-form-item>
            <el-form-item class="text-center">
              <el-button type="primary" @click="submitForm('ruleForm')">{{p_idx? '수정': '등록'}}</el-button>
              <el-button @click="resetForm('ruleForm')">목록</el-button>
            </el-form-item>
          </el-form>
        </div>
        <page-footer></page-footer>
      </div>
    </div>
  </div>
</template>

<script>
  import VuxAlert from '@/mixins/vux-alert';
  import util from '@/mixins/util';
  import validator from "@/mixins/validator";

    export default {
        name: 'PopupDetail',
        components: {
        },
        mixins: [ VuxAlert, validator ],
        data() {
          return{
            title: this.$route.meta.title,
            p_idx : this.$route.params.p_idx,
            ruleForm: {
              p_is_display: '1',
              p_type: 1,
              p_title: '',
              file: [],
              p_dateRange: [],
              p_idx: '',
            },
            rules: {
              p_title: [
                { required: true, message: '필수 입력사항입니다.', trigger: 'blur' },
              ],
              file: [
                { required: true, message: '필수 입력사항입니다.', trigger: 'blur' },
              ],
              p_dateRange: [
                { required: true, message: '필수 입력사항입니다.', trigger: 'blur' },
              ],
            },
          }
        },
        mounted() {
          this.getDetail();
        },
        methods: {
          initData() {
            this.ruleForm= {
              p_is_display: '1',
              p_title: '',
              file: [],
              p_dateRange: [],
              p_idx: '',
            };
          },
          handleFileChange(file, fileList) {
            let maxSize = 1024 * 1024 * 100;
            let type = file.raw.type.split('/');
            if(file.size > maxSize) {
              this.errorAlert('1회 업로드 가능 용량을 초과했습니다!');
              fileList.pop();
            }else if(!(type[1] === 'jpeg' || type[1] === 'png')) {
              this.errorAlert('이미지 파일만 업로드 가능합니다.')
              fileList.pop();
            }else{
              this.ruleForm.file[0] = file;
              this.$forceUpdate();
            }
          },
          handleFileExceed() {
            this.errorAlert('파일은 한개만 가능합니다.')
          },
          getDetail() {
            //fdsfdasfd
            if(this.p_idx) {
              let params = {id: this.p_idx}
              this.$api.$popup.getPopupList(params).then( res => res.Data.Result).then(res => {
                if(res.Info.status === true){
                  this.ruleForm.p_idx = res.List[0].p_idx;
                  this.ruleForm.p_is_display = res.List[0].p_is_display + '';
                  this.ruleForm.p_type = res.List[0].p_type;
                  this.ruleForm.p_title = res.List[0].p_title;
                  this.ruleForm.p_dateRange.push(res.List[0].p_start.split(' ')[0]);
                  this.ruleForm.p_dateRange.push(res.List[0].p_end.split(' ')[0]);
                  if(res.List[0].File.length > 0) {
                    let fileWrap = res.List[0].File;
                    let re = /^http\:\/\/|https\:\/\//;
                    if(!re.test(fileWrap[0].thumb_url)) {
                      fileWrap[0].thumb_url = `http://${fileWrap[0].thumb_url}`;
                    }
                    fileWrap[0].url = res.List[0].File[0].thumb_url;
                    fileWrap[0].name = res.List[0].File[0].org_name;
                    this.ruleForm.file = fileWrap;
                  }
                }
              });
            }
          },
          submitForm(formName) {
            this.$refs[formName].validate((valid) => {
              if (valid) {
                let params = {};
                params.p_is_display = this.ruleForm.p_is_display;
                params.p_type = this.ruleForm.p_type;
                params.p_title = this.ruleForm.p_title;
                params.p_start = this.ruleForm.p_dateRange[0] + ' 00:00:00';
                params.p_end = this.ruleForm.p_dateRange[1] + ' 23:59:59';
                if(this.p_idx) {
                  params.p_idx = this.ruleForm.p_idx;
                  this.$api.$popup.updatePopup(params).then( res => res.Data.Result).then(res => {
                    if(res.Info.status === true){
                      if(this.ruleForm.file[0].hasOwnProperty('raw')) {
                        this.uploadFile(this.p_idx);
                      }else{
                        // this.createAlert({
                        //   title: '확인',
                        //   content: '수정완료',
                        //   btnText: '확인',
                        // });
                        this.updateAlert({'element' : this, })
                      }
                    }else{
                      this.errorAlert(res.Info.reason);
                    }
                  });
                }else{
                  this.$api.$popup.createPopup(params).then( res => res.Data.Result).then(res => {
                    if(res.Info.status === true){
                      this.uploadFile(res.List)
                    }else{
                      this.errorAlert(res.Info.reason);
                    }
                  });
                }
              } else {
                this.validateAlert();
                return false;
              }
            });
          },
          uploadFile(p_idx) {
            let a_container_type = this.ruleForm.p_type === 1? 'popupPc' : 'popupMobile';
            let formData = new FormData();
            formData.append('files', this.ruleForm.file[0].raw);
            formData.append('a_container_type', a_container_type);
            formData.append('a_container_id', p_idx);
            if(this.ruleForm.file[0].a_idx) {
              formData.append('a_idx', this.ruleForm.file[0].a_idx);
            }
            this.$api.$file.updateFile(formData).then( res => res.Data.Result).then(res => {
              if(res.Info.status === true){
                if(this.p_idx) {
                  this.updateAlert({'element' : this, })
                }else{
                  this.saveAlert({'element' : this});
                }
              }else{
                this.errorAlert(res.Info.reason);
              }
            })
          },
          resetForm(formName) {
            window.history.back();
          }
        }
    }
</script>
